<script setup>
import { Icon, Button } from "@components";
import { ref, computed } from "vue";
import { useSettings } from "@store/settings";
const $settings = useSettings();

import { useAppointment } from "@store/appointment";
const $appointment = useAppointment();

import { useService } from "@store/service";
const $service = useService();

import moment from "moment";

const emit = defineEmits(["update:modelValue", "update:time_end", "change"]);

const props = defineProps({
	slots: {
		type: Array,
		default: () => [],
	},
	start: {
		type: String,
		default: "",
	},
	end: {
		type: String,
		default: "",
	},
	date: {
		type: String,
		default: () => moment().format("YYYY-MM-DD"),
	},
	serviceId: {
		type: Number,
		default: 0,
	},
	staffId: {
		type: Number,
		default: 0,
	},
});

const getSlots = async () => {
	await $appointment.fetchAvailableSlots(
		props.date,
		props.serviceId,
		props.staffId
	);

	if (!$appointment.availableSlots) return [];
	let slots = [];

	$appointment.availableSlots.forEach((slot) => {
		let currentTime = moment();
		let startTime = moment(slot.start, "HH:mm");
		let endTime = moment(slot.end, "HH:mm");
		let date = moment(props.date, "YYYY-MM-DD");
		let isToday = date.isSame(moment(), "day");

		// if (!slot.available || (isToday && startTime.isBefore(currentTime))) return
		slots.push({
			label: startTime.format("hh:mm A") + " - " + endTime.format("hh:mm A"),
			start: startTime.format("HH:mm"),
			end: endTime.format("HH:mm"),
			disabled: !slot.available || (isToday && startTime.isBefore(currentTime)),
			selected: slot.start === props.start,
		});
	});

	return slots;
};

const loadSlots = async () => {
	slots.value = await getSlots();
};

// Slots.
const slots = ref([]);
const placeholder = computed(() => {
	return props.start && props.end
		? moment(props.start, "HH:mm").format("hh:mm A") +
				" - " +
				moment(props.end, "HH:mm").format("hh:mm A")
		: "Select Slot";
});

const isOpen = ref(false);
const open = () => {
	isOpen.value = true;
	loadSlots();
};

const setSlot = (slot) => {
	console.log("Slot", slot);

	emit("update:start", slot.start);
	emit("update:end", slot.end);
	emit("change");

	isOpen.value = false;
};
</script>
<template>
	<div class="relative">
		<!-- visible  -->
		<div tabindex="1" class="border focus:ring ring-purple-200 active:ring border-gray-300 rounded-lg px-5 py-2.5 cursor-pointer hover:bg-slate-50 transition text-sm" :class="{ 'text-gray-500': !props.start && !props.end }" @click="isOpen ? false : open()">{{ placeholder }}</div>
		<!-- modal  -->
		<transition name="fade">
			<div v-if="isOpen" class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-10">
				<div class="absolute inset-0 bg-black bg-opacity-30 z-0" @click="isOpen = false"></div>
				<div class="bg-white z-50 w-full max-w-xl shadow-lg rounded fixed border border-slate-300 max-h-[50vh] overflow-y-auto">
					<div class="text-[#344054] text-xl font-semibold px-6 pt-4">Select Slot</div>
					<div class="p-6 pt-3 rounded-lg grid grid-cols-3 gap-3 w-full">
						<div v-for="(slot, index) in slots" :key="index" @click="slot.disabled ? '' : setSlot(slot)" class="h-12 flex items-center justify-center whitespace-nowrap px-3 rounded-lg cursor-pointer hover:bg-gray-50 border border-gray-200 hover:shadow transition text-[13px] font-medium tracking-wide text-center" :class="{
                            'bg-primary-600 text-white hover:bg-primary-600 hover:opacity-90': slot.selected,
                            'text-gray-500 hover:bg-gray-50 hover:shadow': !slot.selected,
                            '!text-gray-400 !cursor-not-allowed': slot.disabled&& !slot.selected
                        }">{{ slot.label }}</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>